/**
 * 基本上报逻辑
 */
import { v4 as uuidV4 } from 'uuid';
import { reportPool } from '@/report/quest';
import { useGlobalGameStore } from '@/store/global/game.store';
import { useAuthStageStore } from '@/store/global/auth.store';
import { getPVID } from '@/utils/pvid';
import { getUrlQuery } from '@/utils/url';
import { unref } from 'vue';

const sessionId = uuidV4();

export async function reportBase(log: any, reportType: ReportType, pageId: string) {
  const gameStore = useGlobalGameStore();
  const authStageStore = useAuthStageStore();
  return reportPool({
    ...log,
    id: uuidV4(),
    sessionid: sessionId,
    pageid: pageId,
    pvid: getPVID(),
    datetime: Date.now(),
    uid: authStageStore.currentUser,
    login_type: '1',
    domain: location.hostname,
    url: location.href,
    path: location.pathname,
    gameid: unref(gameStore.gameCode) || getUrlQuery('game'),
    report_source: 1, // 1-web，2-backend-nodejs 3-h5 4-backend-go
    report_type: reportType,
  });
}

export enum ReportType {
  expose,
  click,
  scroll,
  pv,
  other,
}

export enum MODID {
  FrameWork = '00',
}

export const FrameWork = {
  init: `${MODID.FrameWork}01`,
};
